import { FormGroup } from '@angular/forms';
import { checkBoxHelper, getControl, getGroup } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { CkNormeValuesEnum } from '../../../common/consts/ckNormeValues.enum';
import { checkCkNormeValueHelper, checkCkNormeValueRequiredHelper } from '../../../common/helpers/norme-ck-lookup.helper';
import { MyAllElemCollegioSindacaleEntity } from '../../../../../models/interfaces/revisione.interface';

export const getNormeSrlGroup = (form: FormGroup): FormGroup => getGroup(form, `${formPaths.ammControllo}.my_NormeSrl`);

export const getNormeSrlControl = (form: FormGroup, path: string) => getControl(form, `${formPaths.ammControllo}.my_NormeSrl.${path}`);

export const getAmmControlloControl = (form: FormGroup, path: string) => getControl(form, `${formPaths.ammControllo}.${path}`);

export const checkCkNormeValue = (form: FormGroup): boolean => checkCkNormeValueHelper(form, CkNormeValuesEnum.normeSrl);

export const normeSrlCkHelper = (
    form: FormGroup,
    targetPath: string,
    ckPath: string,
    ckTargetValue: number,
    subFormPath = formPaths.ammControllo,
    suppCondition = true,
    errorStatus?: string
): void => checkBoxHelper(form, targetPath, ckPath, ckTargetValue, subFormPath, suppCondition && checkCkNormeValue(form), errorStatus);

export const normeSrlRequiredHelper = (form: FormGroup, targetPath: string, subFormPath = formPaths.ammControllo): void =>
    checkCkNormeValueRequiredHelper(form, targetPath, CkNormeValuesEnum.normeSrl, subFormPath);

export const checkAllElemCollegioSindacale = (form: FormGroup): boolean => {
    const my_AllElemCollegioSindacale: MyAllElemCollegioSindacaleEntity[] = getAmmControlloControl(form, 'my_AllCollegioSindacale.my_AllElemCollegioSindacale')?.value;
    return !isNilOrEmpty(my_AllElemCollegioSindacale) || !!my_AllElemCollegioSindacale?.length;
};
